import styled from "@emotion/styled"
import { Breadcrumbs } from "@material-ui/core"
import { IStyled } from "style/theme"

export const StyledBreadcrumbs = styled(Breadcrumbs)`
  font-size: 1.4rem;
  color: ${({ theme }: IStyled) => theme.palette.primary.main};
`
